<template>
    <div>
        <v-scale-transition>
            <v-btn
                    v-show="reduced"
                    class="file-handler floating"
                    color="grey darken-4"
                    dark
                    fab
                    @click="reduced = false"
            >
                <v-icon>mdi-progress-upload</v-icon>
            </v-btn>
        </v-scale-transition>
        <!-- CONTENT -->
        <v-slide-y-transition>
            <v-card
                    v-show="!reduced"
                    dark
                    class="file-handler panel"
                    color="grey darken-4"
                    :class="fileHandlerClass"
            >
                <v-card-title>
                    <v-icon
                            large
                            left
                    >
                        mdi-progress-upload
                    </v-icon>
                    <span class="title">Reading files...</span>
                    <v-spacer/>
                    <v-btn
                            flat
                            small
                            icon
                            color="white"
                            @click="reduced = true"
                    >
                        <v-icon>mdi-minus-circle</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="px-3 pb-3 file-handler-subpanel">
                    <v-flex
                            v-for="(filesForRef, refId, refIdIndex) in fileInLoading"
                            xs12
                    >
                        <v-flex
                                v-for="(fileData, fileName, fileIndex) in filesForRef"
                                xs12
                        >
                            <v-layout
                                    row
                                    wrap
                                    class="align-center justify-center"
                            >
                                <v-flex xs6 class="text-truncate">
                                    {{ fileName }}
                                </v-flex>
                                <v-flex xs5 class="px-2"
                                >
                                    <v-progress-linear
                                            v-model="fileData.progress"
                                            color="white"
                                    />
                                </v-flex>
                                <v-flex xs1>
                                    <span>{{ fileData.progress }}%</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-slide-y-transition>
    </div>
</template>

<script>
    import {mapGetters, mapState,} from "vuex";

    export default {
        name: "GlobalFilePanel",
        components: {},
        data() {
            return {
                reduced: false,
            };
        },
        computed: {
            ...mapState({}),
            ...mapGetters("FileInputState", {
                fileInLoading: "getFileInLoading",
            }),
            fileHandlerClass() {
                let styleClass = "";
                if (this.$vuetify.breakpoint.name === "xs") {
                    styleClass = "file-handler-xs";
                } else {
                    styleClass = "file-handler-sm";
                }
                return styleClass;
            },
        },
        methods: {},
    };
</script>

<style lang="scss" scoped>
    .file-handler {
        z-index: 8; // same of v-menu
        position: fixed;
        padding: 2px;
        bottom: 8px;
        right: 8px;
        overflow-y: auto;

        .panel {
            margin-top: 10px;
            overflow-y: auto;
            border-radius: 5px;
            background-color: white;
        }

        .floating {
            animation-name: rotate-center;
            animation-duration: 10s;
        }
    }

    .file-handler-sm {
        width: 784px;
    }

    .file-handler-xs {
        left: 0;
        right: 0;
        margin-left: 8px;
        margin-right: 8px;
        width: calc(100% - 16px);
        max-height: 50vh;
    }


    @-webkit-keyframes rotate-center {
        0% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotate-center {
        0% {
            -webkit-transform: rotate(0);
            transform: rotate(0);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

</style>
